import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { TooltipItem } from "@/sx-layout/components/plotmap/components/TooltipItem";

type Props = {
  plotPlanName: string;
  leftOrRight: "left-aligned" | "right-aligned";
};

export const TooltipPlotPlanDetail: FC<Props> = ({ plotPlanName, leftOrRight }) => {
  const { t } = useTranslation();
  return (
    <div
      style={
        leftOrRight === "left-aligned"
          ? {
              left: "15px",
            }
          : {
              right: "15px",
            }
      }
      className={`
      sx-layout-tooltip
      border-4
      border-[#dea321]
      border-solid
      text-[13px]
      shadow-[0_4px_4px_0px_rgba(0,0,0,0.3)]
      rounded-lg
      p-3
      bg-[#fff]
      z-20
      absolute
      top-4
      `}
    >
      <TooltipItem title={t("name")} value={plotPlanName} />
    </div>
  );
};
